import { render, staticRenderFns } from "./PlayerOptionView.vue?vue&type=template&id=5211a49a&scoped=true"
import script from "./PlayerOptionView.vue?vue&type=script&lang=js"
export * from "./PlayerOptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211a49a",
  null
  
)

export default component.exports